<template>
  <div class="details">
    <h1 class="title">详情</h1>
    <div class="info">
      abc
    </div>
  </div>
</template>

<script>
export default {
  name: 'Details',
  data() {
    return {}
  }
}
</script>

<style lang="stylus">
.details
  background #fff
  padding 20px
  margin 0 auto

  .title
    font-size 28px
    padding 0 0 30px 0

</style>
